import type { Messages } from '@/i18n/messages/en/index.ts'

/** What the people domain's refusals say, in Brazilian Portuguese (checked against the English shape at compile time). */
export const people: Pick<
  Messages['errors'],
  | 'people.no_account_for_email'
  | 'people.cannot_deactivate_yourself'
  | 'people.already_deactivated'
  | 'people.already_active'
  | 'people.confirm_name_to_deactivate'
  | 'people.directory_requires_role'
> = {
  'people.no_account_for_email': () =>
    'Ninguém com esse endereço de e-mail tem conta aqui ainda. Peça para essa pessoa entrar uma vez primeiro.',

  'people.cannot_deactivate_yourself': () =>
    'Você não pode desativar a sua própria conta. Peça a outro administrador para fazer isso.',
  // "desativada" and "ativa" agree with "conta", which is feminine.
  'people.already_deactivated': () => 'Essa conta já está desativada.',
  'people.already_active': () => 'Essa conta já está ativa.',
  // The person's display name is user content and is never translated (D-17).
  'people.confirm_name_to_deactivate': ({ name }) =>
    `Digite ${name} para confirmar que esta conta deve ser desativada.`,

  // "auditor" and "operator" stay in English: they are the role identifiers, not words (D-17).
  'people.directory_requires_role': () =>
    'Para ler o diretório de pessoas é preciso ter o papel “auditor” ou “operator”.'
}
